<template>
    <div>
        <veui-dialog
            :open.sync="modalOpen"
            :closable="false"
            :footless="true"
        >
            <div
                class="dialog-container"
            >
                <veui-icon
                    name="times"
                    class="close-icon"
                    scale="1"
                    @click.native="handleClose"
                />
                <div class="dialog-header">
                    <div class="header-title">咨询流量提升攻略</div>
                    <div class="header-subtitle">同时做到以下两点，流量扶持效果最佳</div>
                </div>
                <div class="dialog-body">
                    <!-- 方法一：开通律师会员 -->
                    <div class="guide-card member-card">
                        <div class="card-badge badge-orange">方法一：提升会员等级</div>
                        <div class="card-main">
                            <div class="card-title-row">
                                <div class="card-title">{{ memberCardTitle }}</div>
                            </div>
                            <div class="card-desc">
                                <div>{{ memberCardDesc }}</div>
                            </div>
                        </div>
                        <div class="card-bottom">
                            <div class="card-status-row">
                                <div class="card-status">
                                    <span class="status-label">当前身份：</span>
                                    <img class="status-tag" :src="vipTagImg"/>
                                    <span v-if="vipTypeSuffix" class="status-hint">{{ vipTypeSuffix }}</span>
                                </div>
                            </div>
                            <div
                                class="card-btn btn-orange"
                                @click="handleAuthorize"
                            >
                                {{ memberBtnText }}
                            </div>
                        </div>
                    </div>
                    <!-- 方法二：提升经营等级 -->
                    <div class="guide-card level-card">
                        <div class="card-badge badge-blue">方法二：提升经营等级</div>
                        <div class="card-main">
                            <div class="card-title-row">
                                <div class="card-title">{{ levelCardTitle }}</div>
                            </div>
                            <div class="card-desc mb-15">
                                <div>{{ levalCardDesc }}</div>
                            </div>
                        </div>
                        <div class="card-bottom">
                            <div class="card-status-row">
                                <div v-if="levelLoaded" class="card-status">
                                    <span class="status-label">当前等级：</span>
                                    <span class="status-value status-value-blue">V{{ level }}</span>
                                    <span class="status-hint">{{ statusHint }}</span>
                                </div>
                                <div v-else class="card-status card-status-placeholder"></div>
                                <div
                                    v-if="level > 0 && level < 5"
                                    class="business-task-link"
                                    @click="handleGotoBusinessCenter"
                                >
                                    <span class="business-task-text">查看经营任务</span>
                                    <img src="https://lvlin-fe-saas.cdn.bcebos.com/assets/blue-arrow.svg">
                                </div>
                            </div>
                            <div class="card-btn btn-blue" @click="handlerHotQuestion">
                                {{ levelBtnText }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </veui-dialog>
        <vip-authorize-modal
            :show="isAuthorizeShow"
            :authorized="true"
            @cancel="handleAuthorizeModalClose"
        />
        <golden-booth-dialog
            :show="isShowGoldenBooth"
            source="diagnose"
            entry-source="diagnose"
            :popup-key="cptPopupKey"
            @cancel="handleGoldenBoothClose"
        />
    </div>
</template>

<script>
/**
 * @desc 咨询流量提升攻略弹窗（非会员引导）
 * @author figma2code
 */
import {Icon, Dialog} from 'veui';
import {mapState} from 'vuex';
import {getBusinessLevelInfo} from '@/request/businessLevel';
import {authorizeVip} from '@/request/vip';
import VipAuthorizeModal from '@/components/vip/vip-authorize-modal';
import GoldenBoothDialog from '@/components/vip/golden-booth-dialog.vue';
import {AsyncQueue} from '@/utils/asyncQueue.js';
import {TRAFFIC_BOOST_POPUP_KEY} from '@/config/localStorage';
const crownIcon = 'https://lvlin-fe-saas.bj.bcebos.com/assets/crown.png';
const memberImg = 'https://lvlin-fe-saas.bj.bcebos.com/assets/member-level.png';
const levelIcon = 'https://lvlin-fe-saas.bj.bcebos.com/assets/level-icon.png';
const levelImg = 'https://lvlin-fe-saas.bj.bcebos.com/assets/level.png';

export default {
    name: 'TrafficBoostDialog',
    components: {
        VipAuthorizeModal,
        GoldenBoothDialog,
        VeuiIcon: Icon,
        VeuiDialog: Dialog
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        source: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            crownIcon,
            memberImg,
            levelIcon,
            levelImg,
            modalOpen: false,
            isAuthorizeShow: false,
            isShowGoldenBooth: false,
            suppressNextCancel: false,
            cptActive: false, // 近30日是否有购买c位
            cptFetched: false,
            cptPopupKey: '',
            level: 0,
            levelLoaded: false,
            autoOpening: false
        };
    },
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore?.vipInfo
        }),
        isVip() {
            return !!+this.vipInfo?.vipStatus;
        },
        // 弹窗埋点前缀：包含入口来源 + 会员类型
        trackPrefix() {
            const memberType = this.vipInfo?.vipStatusName || 'noVip';
            const source = this.source ? this.source + '-' : '';
            return 'traffic-boost-' + source + memberType;
        },
        // 会员类型文本
        vipTypeText() {
            if (!this.isVip) {
                return '基础VIP';
            }
            const {vipStatusName} = this.vipInfo;
            const map = {
                vip: 'SVIP卓越版',
                eliteVip: 'SVIP卓越版',
                freeVip: 'SVIP卓越版',
                beginnerVip: 'SVIP青春版',
                vcardVip: 'V卡会员'
            };
            return map[vipStatusName] || '基础VIP';
        },
        vipTagImg() {
            const vipTagImgMap = {
                noVip: 'https://lvlin-fe-saas.bj.bcebos.com/home/bases-tag.svg',
                beginnerVip: 'https://lvlin-fe-saas.bj.bcebos.com/home/beginners-tag.svg',
                freeVip: 'https://lvlin-fe-saas.bj.bcebos.com/home/elites-tag.svg',
                eliteVip: 'https://lvlin-fe-saas.bj.bcebos.com/home/elites-tag.svg'
            };
            const {vipStatusName} = this.vipInfo || {};
            if (!this.isVip) {
                return vipTagImgMap.noVip;
            }
            return vipTagImgMap[vipStatusName] || vipTagImgMap.noVip;
        },
        // 左卡标题
        memberCardTitle() {
            const {vipStatusName} = this.vipInfo;
            // 青春版会员：升级SVIP卓越会员
            if (vipStatusName === 'beginnerVip') {
                return '升级SVIP卓越会员';
            }
            // 尊享/卓越最高等级会员
            if (this.isHighestVip) {
                return `您已是SVIP卓越会员，C位律师特权${this.cptActive ? '生效中' : '待开通'}`;
            }
            return '开通SVIP卓越会员';
        },
        memberCardDesc() {
            if (this.isHighestVip) {
                return '开通享7日律师推荐首位固展等超强曝光权益，抢占多端黄金展位，赢得更多咨询机会';
            }
            return '律师会员可解锁更多曝光权益与咨询机会，提升您的获客效率。';
        },
        // 会员类型后缀（freeVip显示体验中）
        vipTypeSuffix() {
            const {vipStatusName} = this.vipInfo;
            return vipStatusName === 'freeVip' ? '（体验中）' : '';
        },
        isHighestVip() {
            return this.isVip && ['vip', 'eliteVip'].includes(this.vipInfo.vipStatusName);
        },
        memberBtnText() {
            const {vipStatusName} = this.vipInfo;
            if (this.isHighestVip) {
                return this.cptActive ? '预购更多展位排期' : '查看 [C位律师] 权益详情';
            }
            // 免费体验会员：开通正式会员
            if (vipStatusName === 'freeVip') {
                return '开通正式会员，持续获得权益';
            }
            return '升级会员，解锁更多权益';
        },
        // 右卡标题
        levelCardTitle() {
            if (this.level === 0) {
                return '认证后，解锁经营权益';
            }
            if (this.level >= 5) {
                return '经营等级已达最高';
            }
            return '认领内容提升经营等级';
        },
        levalCardDesc() {
            if (this.level === 0) {
                return '完成律师认证，即可解锁平台经营权益，获得更多曝光与咨询机会。';
            }
            if (this.level >= 5) {
                return '经营等级已达最高，持续完善经营行为与服务表现，流量扶持效果更佳。';
            }
            return '通过开启智能抢答或主动认领内容，提升经营等级，解锁更多曝光与咨询机会。';
        },
        statusHint() {
            const hints = [
                '(认证升至V1，解锁5项权益)',
                '(升至V2解锁6项权益)',
                '(升至V3解锁7项权益)',
                '(升至V4解锁10项权益)',
                '(升至最高V5，解锁全部权益)'
            ];
            return hints[this.level] || '(已达最高，全部权益已解锁)';
        },
        levelBtnText() {
            if (this.level === 0) {
                return '去完成律师认证';
            }
            if (this.level >= 5) {
                return '发布更多内容，提升流量曝光';
            }
            const {vipStatusName} = this.vipInfo;
            // 免费体验会员、青春版会员
            if (['freeVip', 'beginnerVip'].includes(vipStatusName)) {
                return '立即认领内容';
            }
            return '立即认领内容';
        }
    },
    watch: {
        show: {
            immediate: true,
            handler(val) {
                this.modalOpen = val;
                // 每次打开时刷新黄金展位开通状态
                if (!val) {
                    this.cptFetched = false;
                    return;
                }
                if (this.cptFetched) {
                    this.reportShow();
                    return;
                }
                this.getCptEntryStatus().then(ok => {
                    if (ok) {
                        this.reportShow();
                    }
                });
            }
        },
        modalOpen(val) {
            if (!val) {
                if (this.suppressNextCancel) {
                    this.suppressNextCancel = false;
                    return;
                }
                this.$emit('cancel');
            }
        }
    },
    mounted() {
        this.getBusinessLevelInfo();
    },
    methods: {
        // 自动弹出：人群判断与 7 日频控都在弹窗内完成，页面只负责调用
        async tryAutoOpen() {
            if (this.autoOpening || this.modalOpen) {
                return;
            }
            const last = +localStorage.getItem(TRAFFIC_BOOST_POPUP_KEY) || 0;
            if (Date.now() - last < 7 * 24 * 60 * 60 * 1000) {
                return;
            }
            this.autoOpening = true;
            try {
                if (!this.levelLoaded) {
                    await this.getBusinessLevelInfo();
                }
                const {vipStatusName} = this.vipInfo || {};
                let matched = this.level >= 1 && this.level <= 4;
                if (!matched && ['noVip', 'beginnerVip'].includes(vipStatusName)) {
                    matched = true;
                }
                // 卓越会员才查 C 位，结果复用给随后的打开，不再打第二次
                if (!matched && ['eliteVip', 'vip'].includes(vipStatusName)) {
                    const ok = await this.getCptEntryStatus();
                    matched = ok && !this.cptActive;
                }
                if (!matched) {
                    return;
                }
                const asyncQueue = AsyncQueue.getInstance();
                asyncQueue.currentPageSpecialTaskIsEnd = true;
                localStorage.setItem(TRAFFIC_BOOST_POPUP_KEY, String(Date.now()));
                this.modalOpen = true;
                this.$emit('update:show', true);
            }
            finally {
                this.autoOpening = false;
            }
        },
        // 获取黄金展位开通状态
        getCptEntryStatus() {
            return this.$http.get('/bp/api/vip/cpt/entry', {
                params: {scene: 'diagnose'}
            }).then(res => {
                if (+res?.code !== 0) {
                    return false;
                }
                this.cptFetched = true;
                this.cptActive = !!res.data?.cpt_active;
                this.cptPopupKey = res.data?.popup_key_popup || '';
                return true;
            }).catch(() => false);
        },
        reportShow() {
            this.$wywLog.send({
                serverId: 20303,
                area: this.trackPrefix + '-show',
                action: 'show'
            });
            if (!this.isHighestVip) {
                return;
            }
            this.$wywLog.send({
                serverId: 20661,
                area: this.trackPrefix + '-show-' + (this.cptActive ? 'active' : 'inactive'),
                action: 'show'
            });
        },
        async getBusinessLevelInfo() {
            try {
                const res = await getBusinessLevelInfo();
                this.level = res.data?.level ?? 0;
            }
            catch (e) {
                // 接口异常时使用默认值
            }
            finally {
                this.levelLoaded = true;
            }
        },
        handleClose() {
            this.modalOpen = false;
            this.$wywLog.send({
                serverId: 20303,
                area: this.trackPrefix + '-close',
                action: 'click'
            });
        },
        handleGoldenBoothClose() {
            this.isShowGoldenBooth = false;
            this.$emit('cancel');
        },
        handleAuthorizeModalClose() {
            this.isAuthorizeShow = false;
            this.$emit('cancel');
        },
        // 授权客服
        async handleAuthorize() {
            if (this.isHighestVip) {
                if (this.cptActive) {
                    const res = await authorizeVip();
                    if (res.code === '0') {
                        this.$toast.success('客服将尽快电话联系您沟通权益事宜，请注意接听');
                        this.modalOpen = false;
                        this.$wywLog.send({
                            serverId: 20661,
                            area: this.trackPrefix + '-golden-booth-active',
                            action: 'click'
                        });
                    }
                    return;
                }
                this.suppressNextCancel = true;
                this.modalOpen = false;
                this.isShowGoldenBooth = true;
                this.$wywLog.send({
                    serverId: 20661,
                    area: this.trackPrefix + '-golden-booth-inactive',
                    action: 'click'
                });
                return;
            }
            try {
                const res = await authorizeVip();
                if (res.code === '0') {
                    this.suppressNextCancel = true;
                    this.modalOpen = false;
                    this.isAuthorizeShow = true;
                }
                else {
                    this.$toast.error('提交失败，请稍后再试~');
                }
            }
            catch (error) {
                this.$toast.error('授权失败，请稍后再试~');
            }
            this.$wywLog.send({
                serverId: 20303,
                area: this.trackPrefix + '-authorize',
                action: 'click'
            });
        },
        // 前往经营中心
        handleGotoBusinessCenter() {
            this.$wywLog.send({
                serverId: 20303,
                area: this.trackPrefix + '-jingying-center',
                action: 'click'
            });
            this.modalOpen = false;
            this.$router.push({
                name: 'businessCenter',
                query: {fr: 'upgrade-guide'}
            });
        },
        handlerHotQuestion() {
            const isCertification = this.level === 0;
            const isReleaseMore = this.level >= 5;
            const area = `${this.trackPrefix}${
                isCertification ? '-certification-btn' : isReleaseMore
                    ? '-release-more-btn' : '-immediately-claim-btn'
            }`;
            this.$wywLog.send({
                serverId: 20303,
                area,
                action: 'click'
            });
            const routeName = isCertification ? 'businessCenter' : 'hotQuestion';
            this.modalOpen = false;
            this.$router.push({
                name: routeName,
                query: {fr: 'upgrade-guide'}
            });
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .veui-dialog-content {
    width: 680px;
    min-width: 680px;
    max-width: 680px;
    padding: 0;
    border-radius: 8px;
    overflow: hidden;

    .veui-dialog-content-head {
        display: none;
    }

    .veui-dialog-content-body {
        padding: 0;
    }
}

.dialog-container {
    position: relative;
    padding: 21px 24px 24px;

    .close-icon {
        position: absolute;
        right: 24px;
        top: 21px;
        width: 24px;
        height: 24px;
        font-size: 24px;
        line-height: 24px;
        cursor: pointer;
        color: #1e1f24;
        z-index: 1;

        &:hover {
            color: #50525c;
        }
    }

    .dialog-header {
        display: flex;
        align-items: center;
        margin-bottom: 27px;

        .header-title {
            font-family: "PingFang SC";
            font-size: 18px;
            color: #000311;
            font-weight: 500;
            line-height: 18px;
            white-space: nowrap;
        }

        .header-subtitle {
            margin-left: 12px;
            font-family: "PingFang SC";
            font-size: 14px;
            color: #50525c;
            font-weight: 400;
            line-height: 14px;
            white-space: nowrap;
        }
    }

    .dialog-body {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .guide-card {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding: 10px 0 18px;

        .card-badge {
            width: fit-content;
            height: 21px;
            padding: 0 8px;
            border-radius: 3px;
            font-family: "PingFang SC";
            font-size: 13px;
            font-weight: 500;
            line-height: 21px;
            text-align: center;
            margin-left: 10px;
            align-self: flex-start;
        }

        .card-main {
            padding: 17px 18px 0;
        }

        .card-title-row {
            display: flex;
            align-items: center;
            margin-bottom: 9px;

            .card-title {
                font-family: "PingFang SC";
                font-size: 20px;
                font-weight: 600;
                line-height: 20px;
            }
        }

        .card-desc {
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 13px;
            opacity: .7;

            &.mb-15 {
                margin-bottom: 15px;
            }
        }

        .card-bottom {
            padding: 0 18px;
            margin-top: auto;

            .card-status-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 12px;
            }

            .card-status {
                display: flex;
                align-items: center;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 14px;

                &.card-status-placeholder {
                    height: 14px;
                }

                .status-label {
                    color: #848691;
                }

                .status-tag {
                    height: 18px;
                    width: auto;
                }

                .status-value {
                    font-weight: 500;
                }

                .status-hint {
                    color: #848691;
                    margin-left: 4px;
                }
            }

            .business-task-link {
                flex-shrink: 0;
                color: #003580;
                font-size: 13px;
                line-height: 13px;
                font-weight: 500;
                cursor: pointer;
                display: flex;
                align-items: center;

                img {
                    width: 10px;
                    height: 10px;
                    margin-left: 3px;
                }
            }

            .card-btn {
                width: 100%;
                height: 42px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: "PingFang SC";
                font-size: 16px;
                font-weight: 500;
                line-height: 16px;
                cursor: pointer;
                box-sizing: border-box;
                margin-top: 16px;

                &.disabled {
                    opacity: .5;
                    cursor: not-allowed;
                }
            }
        }
    }

    .member-card {
        background-color: #fffcf7;
        border: .5px solid rgba(0, 0, 0, .06);

        .badge-orange {
            background-color: #ffeabf;
            color: #994d00;
        }

        .card-title {
            color: #591d09;
        }

        .card-desc {
            color: #591d09;
        }

        .status-value-orange {
            color: #591d09;
        }

        .btn-orange {
            background-color: #ffeabf;
            color: #8c3a00;
        }
    }

    .level-card {
        background-color: #fafcff;
        border: .5px solid rgba(0, 0, 0, .06);

        .badge-blue {
            background-color: #e0f0ff;
            color: #245fb2;
        }

        .card-title {
            color: #081f4d;
        }

        .card-desc {
            color: #081f4d;
        }

        .status-value-blue {
            color: #081f4d;
            font-weight: 600;
        }

        .btn-blue {
            height: 42px;
            background: #e0f0ff;
            color: #245fb2;
            margin-top: 18px !important;
        }
    }
}
</style>
